/** Fixo (10 dígitos) ou celular (11, com o nono dígito). */
const PHONE_MASK = '(00) 0000-0000||(00) 0 0000-0000';
const CELULAR_MASK = '(00) 0 0000-0000';

/**
 * Máscara do input de telefone para o valor atual: [mask]="phoneMask(control.value)".
 *
 * O ngx-mask 9 só escolhe entre as alternativas ("...||...") enquanto o usuário digita.
 * Um celular que já chega preenchido (do cadastro ou do rascunho) ganhava a máscara de
 * fixo e aparecia sem o último dígito. Com 11 dígitos a máscara passa a ser a do celular;
 * nos demais casos fica a dupla, para que a digitação possa ir de 10 para 11 dígitos.
 */
export function phoneMask(value: unknown): string {
    const digitos = value === null || value === undefined ? '' : String(value).replace(/\D/g, '');

    return digitos.length === 11 ? CELULAR_MASK : PHONE_MASK;
}
